import {
     RESET_GENERAL_STATE,
     SET_AFTER_LOGIN,
     SET_CURRENT_TAB,
     SET_IS_CALLED_CURRENT_USER,
     SET_IS_LOADING,
     SET_IS_NOTICE_LOADING,
     SET_IS_WAITING_ORDER,
     SET_IS_WAITING,
     SET_MESSAGE,
     SET_OVERLAY,
     SET_PAGE_LOADING,
     SET_REMOVE_LOADING,
     SET_SHOW_COMPONENT,
     SET_SHOW_EDIT_POPUP,
     SET_SHOW_LOGIN_AS,
     SET_SHOW_POPUP_DETAIL,
     SET_SHOW_POPUP,
     SET_SHOW_RELATED_OBJECT_WARNING_POPUP,
     SET_SHOW_REMOVE_POPUP,
     SET_SHOW_UNSAVED_CHANGE_POPUP,
     SET_SHOW,
     SET_SIDEBAR_SHOW,
     TOGGLE_THEME,
} from './types';

export const setShowUnsavedChangePopup = () => {
     return {
          type: SET_SHOW_UNSAVED_CHANGE_POPUP,
     };
};

export const setShowPopup = () => {
     return {
          type: SET_SHOW_POPUP,
     };
};

export const setShowRemovePopup = (payload) => {
     return {
          type: SET_SHOW_REMOVE_POPUP,
          payload,
     };
};

export const setShowRelatedObjectWarningPopup = (payload, message = '') => {
     return {
          type: SET_SHOW_RELATED_OBJECT_WARNING_POPUP,
          payload,
          message,
     };
};

export const setShowPopupDetail = (payload) => {
     return {
          type: SET_SHOW_POPUP_DETAIL,
          payload,
     };
};

export const setShowEditPopup = (payload) => {
     return {
          type: SET_SHOW_EDIT_POPUP,
          payload,
     };
};

export const setShowComponent = (payload) => {
     return {
          type: SET_SHOW_COMPONENT,
          payload,
     };
};

export const setIsCalledCurrentUser = (payload) => {
     return {
          type: SET_IS_CALLED_CURRENT_USER,
          payload,
     };
};

export const setIsWaiting = (payload) => {
     return {
          type: SET_IS_WAITING,
          payload,
     };
};

export const setIsWaitingOrder = (payload) => {
     return {
          type: SET_IS_WAITING_ORDER,
          payload,
     };
};

export const setIsLoading = (payload) => {
     return {
          type: SET_IS_LOADING,
          payload,
     };
};

export const setIsNoticeLoading = (payload) => {
     return {
          type: SET_IS_NOTICE_LOADING,
          payload,
     };
};

export const setRemoveLoading = (payload) => {
     return {
          type: SET_REMOVE_LOADING,
          payload,
     };
};

export const setCurrentTab = (payload) => {
     return {
          type: SET_CURRENT_TAB,
          payload,
     };
};

// Reset general state
export const resetGeneralState = (payload) => {
     return {
          type: RESET_GENERAL_STATE,
          payload,
     };
};

export const setOverlay = (overlay) => {
     return {
          type: SET_OVERLAY,
          payload: overlay,
     };
};

export const setPageLoading = (payload) => {
     return {
          type: SET_PAGE_LOADING,
          payload,
     };
};

export const setShow = (payload) => {
     return {
          type: SET_SHOW,
          payload,
     };
};

export const setShowLoginAs = (payload) => {
     return {
          type: SET_SHOW_LOGIN_AS,
          payload,
     };
};

export const setSidebarShow = (sidebarShow) => {
     return {
          type: SET_SIDEBAR_SHOW,
          payload: sidebarShow,
     };
};

export const toggleTheme = () => {
     return {
          type: TOGGLE_THEME,
     };
};

export const setAfterLogin = (afterLogin) => {
     return {
          type: SET_AFTER_LOGIN,
          payload: afterLogin,
     };
};

export const setMessage = (message) => {
     return {
          type: SET_MESSAGE,
          payload: message,
     };
};
